type SidebarHeaderProps = {
  title: string
}

const SidebarHeader = ({ title }: SidebarHeaderProps) => {
  return (
    <div className="flex items-center space-x-2">
      <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-200">{title}</h2>
      <div className="flex-grow border-b-2 border-blue-500"></div>
    </div>
  )
}

export default SidebarHeader
